// extracted by mini-css-extract-plugin
module.exports = {"container":"flags_container__w8rS6","spain":"flags_spain__3RkGX","british":"flags_british__Ytgr7","portugal":"flags_portugal__1F0Qn"};